var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97BAA8"
    },
    d: "M92.104,0H419.9c24.641,0,44.797,20.109,44.797,44.683v422.633c0,24.574-20.159,44.684-44.797,44.684 H92.104c-24.639,0-44.799-20.107-44.799-44.684V44.683C47.305,20.107,67.464,0,92.104,0L92.104,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78A097"
    },
    d: "M47.305,410.651L448.564,10.419c9.843,8.214,16.132,20.541,16.132,34.264v422.633 c0,24.573-20.159,44.684-44.797,44.684H92.104c-24.639,0-44.799-20.107-44.799-44.684V410.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1D7C5"
    },
    d: "M337.237,436.706v10.178v10.178c0,12.361-10.046,22.381-22.439,22.381H197.203 c-12.393,0-22.439-10.021-22.439-22.381v-10.178v-10.178c0-12.361,10.046-22.381,22.439-22.381h117.595 C327.191,414.325,337.237,424.344,337.237,436.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAEEC5"
    },
    d: "M217.138,209.968c3.996-17.735,19.878-30.985,38.869-30.985c18.984,0,34.867,13.25,38.86,30.985 c6.211-3.99,13.607-6.308,21.544-6.308c21.995,0,39.83,17.789,39.83,39.73s-17.835,39.73-39.83,39.73 c-6.154,0-11.975-1.392-17.178-3.876v76.929h-86.458v-76.929c-5.206,2.484-11.028,3.876-17.178,3.876 c-22,0-39.832-17.789-39.832-39.73c0-21.943,17.832-39.73,39.832-39.73C203.535,203.66,210.927,205.979,217.138,209.968 L217.138,209.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1D7C5"
    },
    d: "M299.231,280.07v13.832v62.273h-86.458v-72.341v-3.763v-1.39h86.458V280.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4328"
    },
    d: "M135.831,0h79.666v79.462l-39.82-17.725l-39.846,17.725V0L135.831,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#391B10"
    },
    d: "M464.696,446.884v20.433c0,24.573-20.159,44.684-44.797,44.684H92.104 C67.464,512,47.305,491.893,47.305,467.316v-20.433h417.391V446.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874D20"
    },
    d: "M337.237,446.884v10.178c0,12.36-10.046,22.381-22.439,22.381H197.203 c-12.393,0-22.439-10.021-22.439-22.381v-10.178H337.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#391B10"
    },
    d: "M266.131,446.884c0,4.944-4.018,8.952-8.976,8.952h-2.298c-4.957,0-8.976-4.008-8.976-8.952 s4.018-8.952,8.976-8.952h2.298C262.113,437.93,266.131,441.938,266.131,446.884z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.b79787d1aba8beaa3d4e96442c47948b.svg";
export { ForwardRef as ReactComponent };